import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskedLines, Reveal } from "@/components/site/MaskedLines";
import { SignupForm } from "@/components/site/SignupForm";
import { TiltLion } from "@/components/site/TiltLion";
import { EditableText } from "@/components/cms/EditableText";
import { BlockArea } from "@/components/cms/BlockArea";

const HEADLINE_CLS = "font-display text-[2.6rem] leading-[0.95] sm:text-6xl lg:text-[5.6rem] font-extrabold tracking-[-0.04em]";

const ComingSoon = () => (
  <section data-testid="more-coming-soon" className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pt-6 pb-4">
    <Reveal>
      <p className="font-display text-5xl sm:text-7xl lg:text-8xl font-extrabold leading-[0.95] tracking-[-0.04em]">
        <EditableText k="home_coming" text="More coming" testId="home-coming-text" />{" "}<span className="whitespace-nowrap"><em className="font-serif-accent font-normal italic text-[#E62314]">soon</em>
        {[0, 1, 2].map((i) => (
          <motion.span key={i} className="inline-block text-[#E62314]" animate={{ opacity: [0.2, 1, 0.2] }}
            transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.2 }}>.</motion.span>
        ))}</span>
      </p>
    </Reveal>
  </section>
);

export default function Home() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const lionY = useTransform(scrollYProgress, [0, 1], [0, 60]);

  return (
    <div data-testid="home-page">
      <section ref={ref} className="grain relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pt-10 sm:pt-16 pb-16 lg:pb-24">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
          className="font-mono-label text-xs uppercase tracking-[0.25em] text-[#57534E]">
          <span className="mr-3 inline-block h-2 w-2 rounded-full bg-[#E62314] align-middle" /><EditableText k="home_kicker" text="The list is open" testId="home-kicker" />
        </motion.p>
        <div className="mt-8 grid grid-cols-1 items-center gap-10 md:grid-cols-12">
          <div className="md:col-span-8">
            <EditableText k="home_headline" as="h1" className={HEADLINE_CLS} testId="home-headline-edit"
              text={"Sign up to get\nupdates,\nannouncements\nand news"}>
              <MaskedLines testId="home-headline"
                lines={["Sign up to get", "updates,", "announcements", <>and <em className="font-serif-accent font-normal italic text-[#E62314]">news</em></>]}
                className={HEADLINE_CLS} />
            </EditableText>
          </div>
          <motion.div style={{ y: lionY }} className="mx-auto w-56 sm:w-72 md:col-span-4 md:w-full">
            <TiltLion />
          </motion.div>
        </div>
        <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-12">
          <Reveal className="md:col-span-7 lg:col-span-5 md:col-start-1" delay={0.6}>
            <SignupForm />
          </Reveal>
        </div>
      </section>
      <ComingSoon />
      <BlockArea slug="home" className="pb-24 pt-4" />
    </div>
  );
}
